export enum DrawerMode {
  Navigation = 'navigation',
  Search = 'search',
  CallHub = 'call-hub',
}
